import api from '@/services/api'
import type { staticValues } from './types'

export const getStaticValues = async (endpoint: string): Promise<staticValues> => {
  const response = await api.get(`/${endpoint}`)
  return response.data
}
